<template>
  <div>
    <!-- <h1>Barcode Reader</h1> -->

    <noscript>
        You need to enable JavaScript to run this app.
    </noscript>
    <!-- <div id="scanner"></div> -->

    <div class="barcode-wrapper">
      <div class="quagga-wrapper" v-if="showText == false && showResult == false && showFail == false">
        <v-quagga
          :onDetected="logIt"
          :readerSize="readerSize"
          :readerTypes="['code_128_reader', 'ean_reader']"
          :aspectRatio="aspectRatio"
        ></v-quagga>
      </div>
      <div class="barcodeText">
        <template v-if="showText" >
          <h2>Processing</h2>
          <md-progress-spinner
            class="md-accent"
            md-mode="indeterminate"
            :md-diameter="100"
            :md-stroke="10"
          ></md-progress-spinner>
        </template>
        <template v-if="showResult && project.no_request">
          <h2>A project has been found: {{project.job_name}}</h2>
          <h5>We have emailed the project owners and asked for them to add you to the project</h5>
          <h6>Project Owners</h6>
          <p v-for="po in project.project_owners" :key="po.id">{{po.email}}</p>
          <br/>
          <!-- <md-button class="md-info" @click="getPDF">View GPR Report</md-button> <br/> -->

        </template>
        <template v-if="showResult && !project.no_request">
          <h2>A project has been found: {{project.job_name}}</h2>
          <br/>
          <md-button class="md-info" @click="getLocation">VIEW GPR SURVEY LOCATION</md-button> <br/>
          <md-button class="md-info" @click="getPDF">View GPR Report</md-button> <br/>
          <md-button class="md-info" @click="viewProject">View Project</md-button> <br/>
          <md-button class="md-info" @click="resetScanner">Scan another barcode</md-button>
        </template>
        <template v-if="showFail">
          <h2>No project with that barcode has been found</h2>
          <md-button class="md-info" @click="resetScanner">Scan another barcode</md-button>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import VueQuagga from 'vue-quaggajs';
import api from "@/api";

Vue.use(VueQuagga);

  export default {
    name: 'VueBarcodeTest',
    data () {
      return {
        readerSize: {
          width: 640,
          height: 480
        },
        aspectRatio: { min: 1, max: 2 },
        showText: false,
        dectectedCode: '',
        showResult: false,
        showFail: false,
        project: {
          name: '',
          gpr_report_id: '',
          project_owners: []
        },
        location: {}
      }
    },
    methods: {
      logIt(data) {
        this.showText = true;
        api.getProjectfromBarcode(data.codeResult.code).then((response) => {
          console.log(response);
          if (response.data.found == true){
            console.log('here')
            this.showText = false;
            this.showResult = true;
            this.project = response.data;
            this.location = response.data.location
            console.log(this.project)
          } else {
            this.showText = false;
            this.showFail = true;
          }
        })
      },
      getPDF() {
        // console.log(this.project.gpr_report)
        api.getPDFLink(this.project.gpr_report_id).then((response) => {
          console.log(response);
          //not sure if this will work in production
          var full_url = response.config.baseURL + response.config.url
          window.open(full_url, "_self");
        })
      },
      resetScanner(){
        this.showText = false;
        this.showResult = false;
        this.showFail = false;
      },
      viewProject(){
        this.$router.push(`/projects/${this.project.project_id}`);
      },
      getLocation(){
        this.$router.push(`/projectlocation/${this.project.project_id}?location_id=${this.location.id}`);
      }

    },
    computed: {
      gprAccess(){
        return this.$store.state.user.gpr_access;
      }
    },
  }
</script>

<style lang="scss">
  .barcode-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .quagga-wrapper {
      width: 100%;
    }
    .barcodeText {
      width: 100%;
      text-align: center;
      padding-top: 100px;
    }
  }
</style>
